import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";
const rfiDetailFormStyle = (theme) => ({
  detailInformation: {
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 100),
    overflowY: "auto",
    overflowX: "hidden",
  },
  buttonMenu: {
    "& > *": {
      marginRight: theme.spacing(1),
    },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  textRoot: {
    "& .MuiTextField-root": {
      //   width: "100%",
      marginTop: theme.spacing(2),
    },
  },

  itemRoot: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  itemText: {
    display: "inline",
    color: oceanBlueColor[7],
  },

  editorArea: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },

  elementDivider: {
    borderColor: oceanBlueColor[9],
  },

  divider: {
    marginBottom: theme.spacing(2),
  },

  datePickerField: {
    marginBottom: theme.spacing(0),
    width: "100%",
  },

  webviewer: {
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 130),
  },

  boxArea: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0.8),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1.5),
  },
  checkboxArea: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },

  requireErrorMsg: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
  },
  legendArea: {
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  headerText: {
    fontStyle: "italic",
    fontWeight: "bold",
    color: "#181818",
    fontSize: "1.2rem",
  },
  subHeaderText: {
    fontStyle: "italic",
    fontWeight: "bold",
    color: "#606060",
  },
  fileUploadBtnArea: {
    textAlign: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  formBtn: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  detailsFullScreen: {
    overflowY: "hidden",
  },
  categoryDiv: {
    display: "inline-block",
  },
  textField: {
    marginTop: theme.spacing(1),
  },
  rfiInboxList: {
    overflowY: "auto",
    overflowX: "hidden",
  },
  messageRecipientArea: {
    minHeight: theme.spacing(5),

    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  addFileBtn: {
    background: DodgerBlueColor[11],
    "&:hover": {
      background: DodgerBlueColor[13],
    },

    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  addFileBtnArea: {
    textAlign: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  rfibtnGroup: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  followCheckBox: {},
  checkBoxTitle: { fontWeight: "bold", fontStyle: "italic" },
  checkBoxClass: {
    width: "180px",
  },
  itemBtn: {
    padding: "6px !important",
  },
});

export { rfiDetailFormStyle };
